export default [
  {
    divider: "Ultimate",
    children: [
      // {
      //   title: "Membros",
      //   icon: "mdi-account-group",
      //   to: "admin.members",
      //   permission: 2,
      // },
    ],
  },
  {
    divider: "Gerenciar",
    children: [
      {
        title: "Chaves de API",
        icon: "mdi-key",
        to: "ultimate.api-keys",
      },
      {
        title: "Empresas",
        icon: "mdi-domain",
        to: "ultimate.companies",
      },
      {
        title: "Clientes",
        icon: "mdi-account-multiple",
        to: "ultimate.users",
      },
    ],
  },
  {
    divider: "Plataforma",
    children: [
      {
        title: "Plataformas",
        icon: "mdi-web",
        to: "ultimate.platforms",
      },
      {
        title: "Changelogs",
        icon: "mdi-history",
        to: "ultimate.changelogs",
      },
      {
        title: "Funcionalidades",
        icon: "mdi-star-box",
        to: "ultimate.features",
      },
      {
        title: "Públicos-alvo",
        icon: "mdi-account-group",
        to: "ultimate.featureAudiences",
      },
      {
        title: "Mensageria",
        icon: "mdi-message",
        to: "ultimate.messager",
      },
      {
        title: "Campanhas",
        icon: "mdi-bullhorn",
        to: "ultimate.campaigns",
      },
      {
        title: "Sugestões de produtos",
        icon: "mdi-gift",
        to: "ultimate.merch-products",
      },
    ],
  },
  {
    divider: "Faturamento",
    children: [
      {
        title: "Faturas",
        icon: "mdi-text-box-outline",
        to: "ultimate.invoices",
      },
      {
        title: "Controle de Caixa",
        icon: "mdi-cash-register",
        to: "ultimate.cash-control",
      },
    ],
  },
];
